import { Enviroment } from "enums/Enviroments";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Logger = (message: any, ...optionalParameters: any[]) => {
    if(process.env.REACT_APP_ENVIROMENT != Enviroment.PRODUCTION){
        if(optionalParameters.length > 0) {
            console.log(message, ...optionalParameters);
        }
        else {
            console.log(message);
        }
    }
}